import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import { Box, Button, Typography, Link, TextField, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';

function CaliforniaPropositionsPage() {
    const history = useHistory();

    const [calProp, setCalProp] = useState([]);
    
    const [error, setError] = useState("");

    const [openDialog, setOpenDialog] = useState(false);
    const [voteType, setVoteType] = useState(null);
    const [comment, setComment] = useState("");
    const [activePostId, setActivePostId] = useState(null);

    // Fetch prop info
    useEffect(() => {
        axios.get(`/CaliforniaProposition50`)
            .then(res => setCalProp(res.data))
            .catch(err => console.error("Error loading case", err));
    }, []);

    //console.log(calProp);
    
    if (error) return <p className="text-center text-red-500">{error}</p>;

    const toggleVote = async (calPropId) => {
        try {
            const res = await axios.post(`/calProp/${calPropId}/upvote`);
            const { upvotes, voted } = res.data;

            setCalProp(prevCalProp => ({
                ...prevCalProp,
            upvoteCount: upvotes,
            voted,
            }));

        } catch (err) {
            console.error('Error toggling vote:', err);
        }
    };

    const toggleNo = async (calPropId) => {
        try {
            const res = await axios.post(`/calProp/${calPropId}/no`);
            const { upvotes, calPropVoted } = res.data;


            setCalProp(prevCalProp => ({
                ...prevCalProp,
                noCount: upvotes,
                calPropVoted,
            }));
        } catch (err) {
            console.error('Error toggling vote:', err);
        }
    };

    const toggleYes = async (calPropId) => {
        try {
            const res = await axios.post(`/calProp/${calPropId}/yes`);
            const { upvotes, calPropVoted} = res.data;

            //setCalProp(prev =>
            //    prev.map(calProp => calProp._id === calPropId ? { ...calProp, yesCount: upvotes, calPropVoted } : calProp)
            //);
            
            setCalProp(prevCalProp => ({
                ...prevCalProp,
                yesCount: upvotes,
                calPropVoted,
            }));
        } catch (err) {
            console.error('Error toggling vote:', err);
        }
    };


    const handleOpenDialog = (calPropId) => {
        setActivePostId(calPropId);
        setOpenDialog(true);
    };


    const handleSubmitVote = async () => {
        if (!voteType || !comment.trim() || !activePostId) {
            alert("Please choose vote type and enter a comment.");
            return;
        }


        try {
            await axios.post(`/calProp/${activePostId}/comment`, { text: comment });


            if (voteType === "No") {
                await toggleNo(activePostId);
            } else {
                await toggleYes(activePostId);
            }
            setOpenDialog(false);
            setComment("");
            setVoteType(null);
        } catch (err) {
            console.error(err);
        }
    };

    const noCount = calProp.noCount || 0;
    const yesCount = calProp.yesCount || 0;
    let votePercentage = 0;
    
    if (yesCount > noCount) {
        votePercentage = yesCount/(yesCount+noCount)
    } else if (noCount > yesCount) {
        votePercentage = noCount/(yesCount+noCount)
    }

    let offset = 0;
    if (yesCount > noCount) {
        offset = votePercentage * 50; // move right
    } else if (noCount > yesCount) {
        offset = -votePercentage * 50; // move left
    }

    let tickColor = "blue"; // default at center
    if (offset > 0) {
        tickColor = "#00c853"; // right side
              //tickColor = "red"; // right side
    } else if (offset < 0) {
        tickColor = "red"; // left side
    }

    return (
        <div
                style={{
                    padding: '20px',
                    backgroundColor: '#FFFDF8',
                    minHeight: '100vh',  // ensures it covers the full viewport height
                    boxSizing: 'border-box', // ensures padding doesn't affect layout
                }}
            >

          <div style={{ width: '200px' }}></div>

          {/* Centered Buttons */}
          <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              gap={2}
              flexWrap="wrap"
              sx={{
                  mt: 4,
                  mb: 4,
              }}
                  >
                  <Button
                      variant="outlined"
                      sx={{
                          padding: "6px 12px",
                          borderColor: "#333333",
                          color: "#333333",     
                          backgroundColor: "transparent",
                          '&:hover': {
                              borderColor: "black",
                              color: "black",
                              backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                          },
                      }}
                      onClick={() => history.push('/page2/b/b1')}
                  >
                      Enacted Laws
                  </Button>
                  <Button
                      variant="outlined"
                      sx={{
                          padding: "6px 12px",
                          borderColor: "#333333",
                          color: "#333333",     
                          backgroundColor: "transparent",
                          '&:hover': {
                              borderColor: "black",
                              color: "black",
                              backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                          },
                      }}
                      onClick={() => history.push('/page2/b/b2')}
                  >
                      U.S. Congressional Bills
                  </Button>
                  <Button
                      variant="outlined"
                      sx={{
                          padding: "6px 12px",
                          borderColor: "#333333",
                          color: "#333333",     
                          backgroundColor: "transparent",
                          '&:hover': {
                              borderColor: "black",
                              color: "black",
                              backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                          },
                      }}
                      onClick={() => history.push('/page2/CaliforniaBills')}
                  >
                      California Legislature Bills
                  </Button>
                  <Button
                      variant="outlined"
                      sx={{
                          padding: "6px 12px",
                          borderColor: "#333333",
                          color: "#333333",     
                          backgroundColor: "transparent",
                          '&:hover': {
                              borderColor: "black",
                              color: "black",
                              backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                          },
                      }}
                      onClick={() => history.push(`/page2/CaliforniaPropositions`)}
                  >
                      State Propositions
                  </Button>
                  <Button
                      variant="outlined"
                      sx={{
                          padding: "6px 12px",
                          borderColor: "#333333",
                          color: "#333333",     
                          backgroundColor: "transparent",
                          '&:hover': {
                              borderColor: "black",
                              color: "black",
                              backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                          },
                      }}
                      onClick={() => setOpen(true)}
                  >
                      Propose
                  </Button>
          </Box>

        {/*return (*/}
            <Box
                //key={i} // unique key for each list item
                onClick={() => history.push(`/calProp/${calProp._id}/comments`)}
                p={2} // padding inside box
                my={2} // vertical margin between posts
                border="1px solid #ccc" // light grey border
                borderRadius="8px" // rounded corners
                sx={{
                    position: "relative",
                    maxWidth: 900, // limit width
                    mx: "auto", // center horizontally
                    my: 2, // vertical spacing between each post
                    cursor: "pointer",
                    "&:hover": {
                        backgroundColor: "#f9f9f9"
                    }
                }}
            >

            <Button
                onClick={(e) => {
                    e.stopPropagation();
                    joinVideoCall(bill._id)}
                }
                variant="outlined"
                size="small"
                sx={{
                    position: "absolute",
                    top: 8,
                    right: 8,
                    zIndex: 1
                }}
            >
                Join Voice Call
            </Button>

          <Typography
                  fontWeight="bold"
                  sx={{
                      wordBreak: "break-word",
                      pr: "140px",
                      mb: 1
                  }}
              >
                  {calProp.propTitle}
          </Typography>


         <Typography
                  fontWeight="regular"
                  sx={{
                      wordBreak: "break-word",
                      pr: "140px",
                      mb: 1
                  }}
              >
                  {calProp.propDescription}
          </Typography>


          <Box
              display="flex"
              justifyContent="center"
              sx={{
                  mb: 2,
                  //my: 1
              }}
          >
              <Button
                  variant="outlined"
                  size="small"
                  onClick={(e) => {
                      e.stopPropagation();
                      handleOpenDialog(calProp._id)}
                  }
                  //sx={{ ml: 1 }}
                  sx={{ mr: 1 }}
                  //sx={{ mr: 2.3 }}
                  //sx={{ ml: 2.3 }}
              >
                  Vote
              </Button>
          </Box>


          {/* Vote bar with tick */}
          <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              sx={{ mb: 2 }}
              >
              {/* No Pass Votes */}
              <Typography variant="body2">No</Typography>




              {/* Bar with tick in middle */}
              <Box
                  sx={{
                      position: "relative",
                      height: "2px",
                      backgroundColor: "#ccc",
                      width: "300px",
                      mx: 2
                  }}>
                      {/* Tick in the center */}
                      <Box sx={{
                          position: "absolute",
                          top: "-6px",
                          left: "50%",
                          transform: "translateX(-50%)",
                          width: "2px",
                          height: "14px",
                          backgroundColor: "black"
                      }} />
                
                  {/* Dynamic tick + percentage */}
                  <Box
                      sx={{
                          position: "absolute",
                          top: "-6px",
                          left: `calc(50% + ${offset}%)`,
                          transform: "translateX(-50%)",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center"
                      }}
                      >
                      {/* Tick */}
                      <Box sx={{
                          width: "2px",
                          height: "14px",
                          backgroundColor: tickColor
                      }} />




                      {/* Percentage */}
                      <Typography
                          variant="caption"
                          sx={{ mt: "2px", fontSize: "0.7rem" }}
                      >
                          {(votePercentage * 100).toFixed(0)}%
                      </Typography>
                      </Box>
                  </Box>




                  {/* Pass Votes */}
                  <Typography variant="body2">Yes</Typography>
          </Box>
            <Link
              href={`/api/calProp/pdf/${calProp.doc_id}`}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
          >
              View Proposition
            </Link>




            {/* Upvote button & count */}
            <Box mt={2} display="flex" alignItems="center" gap={1}>
              <Button
                  size="small"
                  variant={calProp.voted ? "contained" : "outlined"}
                  onClick={(e) => {
                      e.stopPropagation();
                      toggleVote(calProp._id)}
                  }
              >
                  ▲ {calProp.voted ? "Unvote" : "Upvote"}
              </Button>
              <Typography variant="body2">{calProp.upvoteCount} Visibility Upvotes | {calProp.noCount} No Votes | {calProp.yesCount} Yes Votes</Typography>
            </Box>
          </Box>
        {/*);*/}


 {/* --- Dialog --- */}
         <Dialog open={openDialog} onClose={() => setOpenDialog(false)} fullWidth>
             <DialogTitle>Cast Your Power Vote</DialogTitle>
             <DialogContent>
                 <Box display="flex" gap={2} mb={2}>
                     <Button
                         variant={voteType === "No" ? "contained" : "outlined"}
                         onClick={() => setVoteType("No")}
                     >
                         No
                     </Button>
                     <Button
                         variant={voteType === "Yes" ? "contained" : "outlined"}
                         onClick={() => setVoteType("Yes")}
                     >
                         Yes
                     </Button>
                 </Box>
                 <TextField
                     fullWidth
                     multiline
                     rows={3}
                     placeholder="Explain your power vote (required)"
                     value={comment}
                     onChange={(e) => setComment(e.target.value)}
                 />
             </DialogContent>
             <DialogActions>
                 <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
                 <Button
                     variant="outlined"
                     onClick={handleSubmitVote}
                     disabled={!comment || !voteType}
                 >
                     Submit Power Vote
                 </Button>
             </DialogActions>
         </Dialog>
  </div>
);
}




export default CaliforniaPropositionsPage;
